import React, { useState } from "react";
import clsx from "clsx";
import PropTypes from "prop-types";
import moment from "moment";
import TableContainer from "@mui/material/TableContainer";
import Paper from "@mui/material/Paper";
import { makeStyles } from "@mui/styles";

import {
  Card,
  CardActions,
  CardContent,
  Checkbox,
  Table,
  Grid,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
  TablePagination,
} from "@mui/material";


import { updateSelectedUserIds } from "store/actions/account";
import { useDispatch, useSelector } from "react-redux";
import { ListCard, ListCardField, ListCards } from "components";
import useCompactLayout from "hooks/useCompactLayout";
import { NavLink } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
  root: {},
  content: {
    padding: 0,
  },
  inner: {
    // minWidth: 1050
  },
  nameContainer: {
    display: "flex",
    alignItems: "center",
  },
  avatar: {
    marginRight: theme.spacing(2),
  },
  actions: {
    justifyContent: "flex-end",
  },
  textLink: {
    textDecoration: "underline",
  },
}));

const KioskTable = (props) => {
  const { className, deviceList, ...rest } = props;

  const classes = useStyles();
  const dispatch = useDispatch();
  const isCompact = useCompactLayout();
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [rowsPerPage, setRowsPerPage] = useState(20);
  const [page, setPage] = useState(0);
  const updateUserIds = (ids) => dispatch(updateSelectedUserIds(ids));
  const userFilter = useSelector((state) => state.account.filter);

  const handleSelectAll = (event) => {
    

    let selectedUsers;

    if (event.target.checked) {
      selectedUsers = deviceList.map((user) => user.id);
    } else {
      selectedUsers = [];
    }

    setSelectedUsers(selectedUsers);
  };

  const handleSelectOne = (event, id) => {
    const selectedIndex = selectedUsers.indexOf(id);
    let newSelectedUsers = [];

    if (selectedIndex === -1) {
      newSelectedUsers = newSelectedUsers.concat(selectedUsers, id);
    } else if (selectedIndex === 0) {
      newSelectedUsers = newSelectedUsers.concat(selectedUsers.slice(1));
    } else if (selectedIndex === selectedUsers.length - 1) {
      newSelectedUsers = newSelectedUsers.concat(selectedUsers.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelectedUsers = newSelectedUsers.concat(
        selectedUsers.slice(0, selectedIndex),
        selectedUsers.slice(selectedIndex + 1)
      );
    }

    setSelectedUsers(newSelectedUsers);
    updateUserIds(newSelectedUsers);
  };

  const handlePageChange = (event, page) => {
    setPage(page);
  };

  const handleRowsPerPageChange = (event) => {
    setRowsPerPage(event.target.value);
  };

  const filterUsers = () => {
    if (!userFilter || userFilter === null || userFilter.trim() === "") {
      return deviceList;
    }

    return deviceList.filter(
      (user) =>
        (user.restaurantId && user.restaurantId.toLowerCase().includes(userFilter)) ||
        (user.deviceName && user.deviceName.toLowerCase().includes(userFilter)) ||
        (user.version &&  user.version.includes(userFilter)) ||
        (user.buildNumber && String(user.buildNumber).includes(userFilter)) ||
        (user.os && String(user.os).includes(userFilter))
    );
  };

  const getTimeString = (date) => {
    if (typeof date === "object" && '_seconds' in date) {
      return moment(new Date(date._seconds * 1000)).format('DD/MM/YYYY')
    }
    return moment(date * 1000).format('DD/MM/YYYY HH:mm')
  };

  const getTypesString = (types) => {
    const names = types.map(type => type.tableNumber);
    return names.join(', ');
  }

  // One slice, shared by both layouts, so page state survives a resize.
  const visibleDevices = filterUsers();
  const pagedDevices = visibleDevices.slice(page * rowsPerPage, rowsPerPage * page + rowsPerPage);

  const renderCards = () => (
    <ListCards count={visibleDevices.length} noun="kiosk" empty="No kiosks to show.">
      {pagedDevices.map((device) => (
        <ListCard
          key={device.id}
          data-testid="kiosk-card"
          header={
            <>
              <Checkbox
                checked={selectedUsers.indexOf(device.id) !== -1}
                color="primary"
                onChange={(event) => handleSelectOne(event, device.id)}
                size="small"
                inputProps={{ "aria-label": `select kiosk ${device.id}` }}
              />
              <NavLink to={`/kiosk/${device.id}`}><Typography variant="body1" className={classes.textLink}>{device.code}</Typography></NavLink>
            </>
          }
        >
          <ListCardField label="Types" value={device.tables ? getTypesString(device.tables) : ''} />
          <ListCardField label="Payment" value={device.isPaymentRequired ? 'Yes' : 'No'} />
          <ListCardField label="Updated" value={getTimeString(device.updatedAt)} />
        </ListCard>
      ))}
    </ListCards>
  );

  return (
    <Grid lg={12} md={12} xl={12} xs={12}>
      <Card {...rest} className={clsx(classes.root, className)}>
        <CardContent className={classes.content}>
          {isCompact ? renderCards() : (
          <div className={classes.inner}>
            <TableContainer component={Paper}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell padding="checkbox">
                      <Checkbox
                        checked={selectedUsers.length === deviceList.length}
                        color="primary"
                        indeterminate={
                          selectedUsers.length > 0 &&
                          selectedUsers.length < deviceList.length
                        }
                        onChange={handleSelectAll}
                      />
                    </TableCell>
                    <TableCell>Kiosk Code</TableCell>
                    <TableCell>Types</TableCell>
                    <TableCell>Payment</TableCell>
                    <TableCell>Update Time</TableCell>
                   
                  </TableRow>
                </TableHead>
                <TableBody>
                  {pagedDevices
                    .map((device) => (
                      <TableRow
                        className={classes.tableRow}
                        hover
                        key={device.id}
                        selected={
                          selectedUsers.indexOf(device.id) !== -1
                        }
                      >
                        <TableCell padding="checkbox">
                          <Checkbox
                            checked={
                              selectedUsers.indexOf(device.id) !== -1
                            }
                            color="primary"
                            onChange={(event) =>
                              handleSelectOne(event, device.id)
                            }
                            value="true"
                          />
                        </TableCell>
                        <TableCell>

                        <NavLink to={`/kiosk/${device.id}`}>
                              <Typography
                                variant="body1"
                                className={classes.textLink}
                              >
                                {" "}
                                {device.code}
                              </Typography>
                            </NavLink>
                         
                       
                        </TableCell>
                        <TableCell>{`${device.tables ? getTypesString(device.tables) :''}`}</TableCell>
                        <TableCell>{device.isPaymentRequired ? "Yes": "No"}</TableCell>
                      
                        <TableCell> {getTimeString(device.updatedAt)}</TableCell>
                     
                      </TableRow>
                    ))}
                </TableBody>
              </Table>
            </TableContainer>
          </div>
          )}
        </CardContent>
        <CardActions className={classes.actions}>
          <TablePagination
            component="div"
            count={visibleDevices.length}
            onPageChange={handlePageChange}
            onRowsPerPageChange={handleRowsPerPageChange}
            page={page}
            rowsPerPage={rowsPerPage}
            rowsPerPageOptions={[20, 50, 100]}
          />
        </CardActions>
      </Card>
    </Grid>
  );
};

KioskTable.propTypes = {
  className: PropTypes.string,
  deviceList: PropTypes.array.isRequired,
};

export default KioskTable;
